import React from 'react';
import PropTypes from 'prop-types';
import { PortalQualificationPropType } from '../../../../CustomPropTypes/PortalPropTypes';
import { QualificationTraits } from './QualificationTraits';
import './PortalQualificationKeyInformation.scss';
import { PortalJoinQualificationButton } from '../../PortalButton/PortalJoinQualificationButton';

// eslint-disable-next-line react/prefer-stateless-function
export class PortalQualificationKeyInformation extends React.Component {
  static displayName = 'PortalQualificationKeyInformation';

  static propTypes = {
    anchor: PropTypes.string.isRequired,
    qualification: PortalQualificationPropType.isRequired,
    onCallToAction: PropTypes.func.isRequired,
    onCtaButtonClicked: PropTypes.func.isRequired,
  };

  render() {
    const {
      anchor,
      qualification,
      onCtaButtonClicked,
      onCallToAction,
    } = this.props;

    return (
      <portal-qualification-key-information id={anchor}>
        <div className="row portal-section">
          <div className="columns small-11 small-centered medium-10 medium-centered">
            <QualificationTraits {...{ qualification }} />
            <div className="text-center">
              <PortalJoinQualificationButton
                {...{ qualification, onCtaButtonClicked }}
                onClick={onCallToAction}
              />
            </div>
          </div>
        </div>
      </portal-qualification-key-information>
    );
  }
}
